<div class="div-action-top">
  <div>
    <div class="d-flex flex-wrap">
      <nz-form-item class="spacepad">
        <nz-form-control>
          <input  [(ngModel)]="filter.sid" nz-input placeholder="SID" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <input [(ngModel)]="filter.phoneNo" nz-input placeholder="Số điện thoại" />
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <nz-date-picker style="width: 100%" [(ngModel)]="filter.fromDate" nzPlaceHolder="Từ ngày..." [nzFormat]="dateFormat">
          </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item class="spacepad">
        <nz-form-control>
          <nz-date-picker style="width: 100%" [(ngModel)]="filter.toDate" nzPlaceHolder="Đến ngày..." [nzFormat]="dateFormat"></nz-date-picker>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="spacepad">
        <nz-form-control>
          <button nz-button class="mgr10" nzType="primary" nzSize="default" (click)="doSearch()">
            <span class="fa fa-fw fa-search"></span>
          </button>
          <button nz-button class="mgr15" nzType="dashed" nzSize="default" (click)="clearSearch()">
            <span class="fa fa-fw fa-times"></span>
          </button>
          <button nz-button class="mgr10" nzType="primary" nzSize="default" class="btn-green"
                  (click)="exportData()">
            <span class="fa fa-fw fa-file-excel"></span>
            Xuất Excel
          </button>
        </nz-form-control>
      </nz-form-item>
      <!--<button style="margin-right: 10px" nz-button nzType="primary" nzSize="default" [disabled]="lstResultChecked.length==0" (click)="printMultiResult()">In</button>
      <button nz-button nzType="primary" nzSize="default" [disabled]="lstResultChecked.length==0" (click)="exportPDF()">Xuất PDF</button>-->
    </div>
  </div>
</div>
<div class="data-table">
  <dx-data-grid
    id="gridContainer"
    [dataSource]="dataSource"
    [remoteOperations]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [width]="'100%'"
    [height]="dxGridHeight"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
    [allowColumnResizing]="true"
    columnResizingMode="widget"
    [columnMinWidth]="50"
    [columnAutoWidth]="true"
  >
    <dxo-load-panel [enabled]="true"></dxo-load-panel>
    <dxo-scrolling mode="standard"></dxo-scrolling>
    <dxo-sorting mode="none"></dxo-sorting>
    <dxo-header-filter [visible]="false"></dxo-header-filter>
    <dxo-filter-row [visible]="false"></dxo-filter-row>
    <dxo-paging [pageSize]="defaultPageSize || 20" [pageIndex]="0"></dxo-paging>
    <dxo-pager
      [visible]="true"
      [displayMode]="'full'"
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[20, 50, 100, 200]"
      [showInfo]="true"
      [showNavigationButtons]="true"
    ></dxo-pager>
    <!--<dxi-column [fixed]="true"
                caption="STT"
                [width]="55"
                [allowFiltering]="false"
                [allowSorting]="false"
                cssClass="text-center"
                cellTemplate="cellIndexTemplate"
    ></dxi-column>-->
    <!--<dxo-group-panel [visible]="true"></dxo-group-panel>-->
    <dxi-column caption="Ngày gửi" [width]="140" dataField="dateSend" dataType="date" format="HH:mm dd/MM/yyyy"></dxi-column>
    <dxi-column caption="Nội dung" dataField="messageSend"></dxi-column>
    <dxi-column caption="SID" dataField="orderCode" [width]="100"></dxi-column>
    <dxi-column caption="SĐT" dataField="phoneNo" [width]="100"></dxi-column>
    <dxi-column caption="Người gửi" dataField="userSend" [width]="140"></dxi-column>
  </dx-data-grid>
  <!--<footer class="grid-footer">
    Tổng số: {{numberRecord}} bản ghi
  </footer>-->
</div>
